import urls from "js/routes/urls"

export default route => urls[route.name].props(route)
